import { auth } from "../config";
import Cookies from "js-cookie";

/** Sync flag so Cloudflare edge can allow /admin before the JWT cookie is written. */
export const setAuthSessionFlag = () => {
  Cookies.set("auth_session", "1", {
    secure: import.meta.env.PROD,
    sameSite: "lax",
    path: "/",
    expires: 7,
  });
};

export const clearAuthSessionFlag = () => {
  Cookies.remove("auth_session", { path: "/" });
};

export const setAuthCookie = async () => {
  try {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      // Set the auth cookie with the token
      Cookies.set("auth", token, {
        secure: import.meta.env.PROD,
        sameSite: "lax",
        path: "/",
        expires: 7, // expires in 7 days
      });
    }
  } catch (error) {
    console.error("Error setting auth cookie:", error);
  }
};

export const removeAuthCookie = () => {
  Cookies.remove("auth", { path: "/" });
  clearAuthSessionFlag();
};
